import { render, staticRenderFns } from "./m-dropdown.vue?vue&type=template&id=3f490e68&scoped=true"
import script from "./m-dropdown.vue?vue&type=script&lang=js"
export * from "./m-dropdown.vue?vue&type=script&lang=js"
import style0 from "./m-dropdown.vue?vue&type=style&index=0&id=3f490e68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f490e68",
  null
  
)

export default component.exports